module.exports = __webpack_public_path__ + "static/media/resize-horizontal.9c3f5898.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/chatbot/assets/resize-horizontal.svg
// module id = 1004
// module chunks = 0